var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.imageSrc !== '')?_c('img',{staticClass:"d-inline",class:{'lg': _vm.large, 'sm': _vm.small},attrs:{"src":_setup.imageSrc,"alt":"","loading":"lazy"}}):_c(_setup.AccountAddress,{attrs:{"address":_vm.address}})
}
var staticRenderFns = []

export { render, staticRenderFns }